import { render, staticRenderFns } from "./editpetshop.vue?vue&type=template&id=80987218&"
import script from "./editpetshop.vue?vue&type=script&lang=js&"
export * from "./editpetshop.vue?vue&type=script&lang=js&"
import style0 from "./editpetshop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports